import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import MotionAppear from '../Components/MotionAppear'
import { fullCenter, pastelBlue, pastelRed, textStyle } from './Main/constants'
import { Masonry } from '@mui/lab'
import { useFirestore } from '../Firebase/FirestoreProvider'
import { EditableTypography } from '../Components/EditableTypography'
import { useAuth } from '../Firebase/AuthProvider'

export default function Reference() {
    const { isAdmin } = useAuth();
    const { data, changeData } = useFirestore();
    const references = data?.references || [];


    const reversed = references
        .map((r, index) => ({ r, originalIndex: index }))
        .reverse();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', alignContent: 'center' }}>
            {isAdmin && <Box sx={{ display: 'flex', flexDirection: 'row', pb: '40px' }}><Box component='span'
                sx={{
                    width: '34px', height: '34px', maxWidth: '34px', maxHeight: '34px', minWidth: '34px', borderRadius: '50%',
                    bgcolor: pastelBlue,
                    scale: 1,
                    transition: 'scale 0.2s ease-in-out',
                    "&:hover": { scale: 1.05 },
                    zIndex: 14, cursor: 'pointer', ...fullCenter, mt: '12px'
                }}
                onClick={(e) => {
                    if (isAdmin) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    const newReferences = [...references, { name: '', text: '' }]
                    changeData('references', newReferences);

                }} onMouseDown={(e) => {
                    if (isAdmin) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }}>

                <Typography sx={{ fontWeight: 'bold', fontSize: '28px', mb: '4px' }}>+</Typography>
            </Box>
                <Box component='span'
                    sx={{
                        width: '34px', height: '34px', maxWidth: '34px', maxHeight: '34px', minWidth: '34px', borderRadius: '50%',
                        bgcolor: pastelRed,
                        scale: 1,
                        transition: 'scale 0.2s ease-in-out',
                        "&:hover": { scale: 1.05 }, ml: '12px',
                        zIndex: 14, cursor: 'pointer', ...fullCenter, mt: '12px'
                    }}
                    onClick={(e) => {
                        if (isAdmin) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        const newReferences = [...references].slice(0, -1);
                        changeData('references', newReferences);

                    }} onMouseDown={(e) => {
                        if (isAdmin) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }}>

                    <Typography sx={{ fontWeight: 'bold', fontSize: '28px', mb: '4px' }}>-</Typography>
                </Box>
            </Box>}

            <Masonry
                columns={{ xs: 1, sm: 1, md: 2, xl: 3 }}
                spacing={4}
                sx={{ maxWidth: { sm: '600px', md: 'none' } }}
            >
                {reversed.map(({ r, originalIndex }, i) => (
                    <MotionAppear key={'Reference' + i} amount={0.1}>
                        <Box
                            sx={{
                                borderRadius: '20px',
                                bgcolor: '#FFF8E1',
                                border: '2px solid #F2D683',
                                //boxShadow: '1px 1px 2px rgba(0,0,0,0.2)',
                                minHeight: '140px',
                                ...(r?.sx ? r.sx : {}),
                            }}
                        >
                            <Box sx={{ p: '24px', px: { xs: '24px', sm: '32px' } }}>
                                <EditableTypography
                                    path={`references.${originalIndex}.text`}
                                    sx={{
                                        mt: '12px', ...textStyle, color: '#9A6A12',
                                    }}
                                />
                                <EditableTypography
                                    bottom={-40}
                                    path={`references.${originalIndex}.name`}
                                    sx={{
                                        mt: '32px', ...textStyle, fontWeight: 'bold',
                                        color: '#9A6A12',
                                    }}
                                />

                            </Box>
                        </Box>
                    </MotionAppear>
                ))}
            </Masonry>
        </Box>
    )
}
